import api from '@services/api';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { toast } from 'react-toastify';
import type { FormErrors } from '@customTypes/errors';
import { isValidPassword } from '@utils/validations';
import { datadogRum } from '@datadog/browser-rum';

const useForm = () => {
  const navigate = useNavigate();
  const { code } = useParams();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<FormErrors | null>(null);

  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const data = Object.fromEntries(formData.entries());

    if (!isValidPassword(data.password as string)) {
      setErrors({ password: ['A senha deve ter pelo menos 8 caracteres, incluindo letras maiúsculas, minúsculas e caracteres especiais.'] });
      return;
    };

    if (data.password !== data.confirmPassword) {
      setErrors({ confirmPassword: ['As senhas não coincidem.'] });
      return;
    };

    setLoading(true);
    setErrors(null);

    try {
      const response = await api.post('/account/reset-password', {
        password: data.password,
        code,
      });

      if (response?.status === 200) {
        toast.success('Senha redefinida com sucesso!');
        navigate('/', { replace: true });
      } else if (response?.data?.errors) {
        setErrors(response.data.errors);
      }
    } catch (error) {
      toast.error('Erro ao redefinir sua senha. Tente novamente.');
      datadogRum.addError(new Error('Fail to reset password'), {
        error,
        email: data.email,
      });
    } finally {
      setLoading(false);
    };
  };

  return {
    onSubmit,
    loading,
    errors,
  };
};

export default useForm;
